import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconPersonVerifiedSvg } from "./IconPersonVerifiedSvg.mjs";
const IconPersonVerified = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconPersonVerifiedSvg, ...svgProps }) });
export {
  IconPersonVerified
};
